// NPM
import React, { useEffect, useState } from 'react'
import { useRecoilState } from "recoil";
import { isNil, isEmpty } from 'lodash';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet";

// COMPONENTS
import ProductCart from 'Components/product/product-cart';
import ProductCheckout from 'Components/product/product-checkout';

// ATOM
import { CartAtom } from "Recoil/order.atom";

// SERVICE
import { createOrder, fetchCartList, addToCartList, deleteCartItem, updateCartItem } from 'Services/order.services';

// HELPERS
import { toaster, encode } from 'Helpers/index';

// STYLE
import './product-cart.scss';

// HOOK
import useSession from 'Hooks/session.hook';

interface ProductCartPageProps {

}

const ProductCartPage: React.FC<ProductCartPageProps> = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [cartState, setCartState] = useRecoilState<any>(CartAtom);

  const [carListItems, setCarListItems] = useState({});

  const addToCart = async (data) => {
    setCartState({ ...cartState, status: { ...cartState.status, create: 'loading' } });

    const responseData = await addToCartList(data);

    if (!isNil(responseData) && !isNil(responseData.order)) {
      setCartState({
        ...cartState,
        status: { ...cartState.status, create: 'success' },
      });
    }
    else {
      setCartState({
        ...cartState,
        status: { ...cartState.status, create: 'error' }
      });
      toaster('error', t('toaster.FailedtoAddCartItem'))
    }
  }

  const updateCart = async (data) => {
    setCartState({ ...cartState, status: { ...cartState.status, update: 'loading' } });

    const responseData = await updateCartItem(data);
    if (!isNil(responseData) && responseData.updated) {
      setCartState({
        ...cartState,
        status: { ...cartState.status, update: 'success' },
      });
      //    toaster('success', 'Cart updated successfully')
      fetchCartListItemsLength()
    }
    else {
      setCartState({
        ...cartState,
        status: { ...cartState.status, update: 'error' }
      });

      toaster('error', t('toaster.FailedtoUpdateCartItem'))
    }
  }


  const fetchCartListItems = async () => {
    setCartState({ ...cartState, status: { ...cartState.status, fetch: 'loading' } });

    const responseData = await fetchCartList();

    if (!isNil(responseData) && responseData.cartID) {
      setCartState({
        ...cartState,
        status: { ...cartState.status, fetch: 'success' },
        list: responseData.items
      });
      setCarListItems(responseData)
    }
    else {
      setCartState({
        ...cartState,
        status: { ...cartState.status, fetch: 'error' }
      });

      // toaster('error', 'Failed to fetch cart items')
    }
  }


  const fetchCartListItemsLength = async () => {
    setCartState({ ...cartState, status: { ...cartState.status, fetch: 'loading' } });

    const responseData = await fetchCartList();

    if (!isNil(responseData) && responseData.cartID) {
      setCartState({
        ...cartState,
        status: { ...cartState.status, fetch: 'success' },
        list: responseData.items
      });
    }
    else {
      setCartState({
        ...cartState,
        status: { ...cartState.status, fetch: 'error' }
      });
    }
  }

  useEffect(() => {
    const session = useSession();
    if (isEmpty(session)) {
        history.push('/login');
        return;
    }

    fetchCartListItems()
  }, [])

  return (
    <React.Fragment>
      <Helmet>
        <title>
          Cart
        </title>
      </Helmet>
      <div className="page pageWrapper">
        <div className="page">
          <ProductCart
            handleUpdateToCart={updateCart}
            cartList={carListItems}
            status={cartState.status}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProductCartPage;
